import { RichText } from "components/RichTextWidget";
import {
  Heading4,
  Heading5,
  Icon,
  PageLink,
  Paragraph,
} from "shared/components";

import { SingleImage } from "../SingleImage";
import { SliderImages } from "../SliderImages";
import styles from "./Item.module.scss";

export const Item = ({ item }) => {
  const Block = (item.images || []).length === 1 ? SingleImage : SliderImages;

  return (
    <div className={styles.item}>
      {item.images && <Block images={item.images} className={styles.image} />}
      <div className={styles.content}>
        <Heading5 className={styles.title}>{item.title}</Heading5>
        {item.subtitle && (
          <Heading4 className={styles.subtitle} color="brand">
            {item.subtitle}
          </Heading4>
        )}
        {item.labels && (
          <Paragraph className={styles.labels} color="blue" uppercase>
            {item.labels}
          </Paragraph>
        )}
        <RichText value={item.description} className={styles.description} />
        {item?.link && (
          <PageLink
            link={item?.link}
            className={styles.link}
            target={item?.target}
          >
            <Paragraph
              className={styles.button}
              color="brand"
              appearance="bigger"
            >
              {item.buttonText}
            </Paragraph>
            <Icon className={styles.icon} name="arrow_right" />
          </PageLink>
        )}
      </div>
    </div>
  );
};
